import {
  addNavMenuItem,
  registerBulkAction,
  registerFormInputComponent,
  registerDataTableComponent,
} from "@bb-vendure/admin-ui/core";
import { deleteBulkAction } from "./components/bulkAction";
import { ProductTypeDropdownComponent } from "./components/product-type-dropdown/product-type-dropdown.component";
import { ProductTypeColumnComponent } from "./components/product-type-column/product-type-column.component";

export default [
  registerBulkAction(deleteBulkAction),
  registerFormInputComponent(
    "product-type-dropdown",
    ProductTypeDropdownComponent
  ),

  registerDataTableComponent({
    component: ProductTypeColumnComponent,
    tableId: "product-list",
    columnId: "productType",
  }),
];
